"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BackgroundFilterVideoFrameProcessorDelegate_1 = require("../backgroundfilter/BackgroundFilterVideoFrameProcessorDelegate");
/**
 * This class adds the functionality to allow for a set of unique observers to be added to the
 * video frame processor.
 */

/** @internal */


var BackgroundReplacementVideoFrameProcessorDelegate = /*#__PURE__*/function (_BackgroundFilterVide) {
  _inherits(BackgroundReplacementVideoFrameProcessorDelegate, _BackgroundFilterVide);

  var _super = _createSuper(BackgroundReplacementVideoFrameProcessorDelegate);

  function BackgroundReplacementVideoFrameProcessorDelegate() {
    _classCallCheck(this, BackgroundReplacementVideoFrameProcessorDelegate);

    return _super.apply(this, arguments);
  }

  return BackgroundReplacementVideoFrameProcessorDelegate;
}(BackgroundFilterVideoFrameProcessorDelegate_1.default);

exports.default = BackgroundReplacementVideoFrameProcessorDelegate;